var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('span',{staticClass:"header-online",on:{"click":_vm.onViewOnline}},[_c('a-icon',{staticStyle:{"font-size":"16px","padding":"4px"},attrs:{"type":"team"}})],1),_c('online-users',{ref:"onlineUsers",attrs:{"visible":_vm.modalVisible},on:{"cancel":function($event){_vm.modalVisible = false}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }